import { ClipboardClock, ArrowLeftRight, RotateCw, ListChecks } from 'lucide-react'
import { SubscriberController } from '../../../../../services/controllers/subscription';
import { useSubscribers } from '../../../../../store/subscription/useSubscribers';

import { Action } from "../../../../../components/ui/Action";

export function CycleActions({ cycle }) {
  const CSubscriber = SubscriberController();
  const cycleKey = `${cycle.id}-${cycle.data.invoiceId}-${cycle.data.chargeId}`

  return (
    <div className="w-full flex justify-end gap-6">
      <div className='flex gap-2 [&>*]:w-fit'>
        <Action.Root
          outline
          type="button"
          custom="#0376b1"
          title="Histórico de cobranças"
          name={`see-cycle-history-${cycleKey}`}
          onClick={() => CSubscriber.findCycleTransactions(cycle)}
        >
          <Action.Icon icon={ClipboardClock} size={22} />
        </Action.Root>
        <Action.Root
          outline
          status="400"
          type="button"
          title="Ver Detalhes"
          name={`see-cycle-detail-${cycleKey}`}
          onClick={() => CSubscriber.findCycleDetails(cycle)}
        >
          <Action.Icon icon={ListChecks} size={22} />
        </Action.Root>
      </div>
    </div>
  )
}
